import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FiMapPin, FiPhone, FiClock } from "react-icons/fi";
import { FaRegEnvelope } from "react-icons/fa6";
import { Link } from 'react-router-dom';
import useTitle from '../hooks/useTitle';
import './ContactsPage.css';

const Contacts = () => {
    // Задаем название сайта
    useTitle('Контакты');

    return (
        <Container className="contacts-page py-4">
            {/* Хлебные крошки */}
            <div className="breadcrumbs mb-3">
                <Link to="/">Главная</Link> {' > '} <span>Контакты</span>
            </div>
            <h1 className="contacts-title mb-3">Контакты</h1>
            <p className="contacts-subtitle mb-4">
                Свяжитесь с нами удобным для вас способом
            </p>
    
            <div className="contacts-content mb-5">
                <Row className="contacts-card">
                    <Col lg={6} className="contacts-map">
                        <iframe src="https://yandex.ru/map-widget/v1/?um=constructor%3Aa202e5f74ace469f75e1e9d34bec292e6941c3bf50660c77c4c7f78b8c19d9e5&amp;source=constructor" 
                            width="100%" 
                            height="100%" 
                            frameborder="0"
                            title="Офис ООО «Перформанс»"
                            // loading="lazy"
                        ></iframe>
                    </Col>
                    <Col lg={6} className="contacts-info">
                        <div className="contact-item">
                            <div className="contact-icon">
                                <FiMapPin className="icon" />
                            </div>
                            <div className="contact-text">
                                г. Тюмень, ул. Мельничная 17
                            </div>
                        </div>
            
                        <div className="contact-item">
                            <div className="contact-icon">
                                <FiPhone className="icon" />
                            </div>
                            <div className="contact-text">
                                <a href="tel:+73452614940">+7 (3452) 61-49-40</a>
                            </div>
                        </div>
                        
                        <div className="contact-item">
                            <div className="contact-icon">
                                <FiPhone className="icon" />
                            </div>
                            <div className="contact-text">
                                <a href="tel:+79323214940">+7 (932) 321-49-40</a>
                            </div>
                        </div>

                        <div className="contact-item">
                            <div className="contact-icon">
                                <FiPhone className="icon" />
                            </div>
                            <div className="contact-text">
                                <a href="tel:+79612149991">+7 (961) 214-99-91</a>
                            </div>
                        </div>
            
                        <div className="contact-item">
                            <div className="contact-icon">
                                <FaRegEnvelope className="icon" />
                            </div>
                            <div className="contact-text">
                                <a href="mailto:dos.sreda@yandex.ru">dos.sreda@yandex.ru</a>
                            </div>
                        </div>
            
                        <div className="contact-item">
                            <div className="contact-icon">
                                <FiClock className="icon" />
                            </div>
                            <div className="contact-text">
                                пн-пт: 9:00 - 18:00 (GMT +5)<br />
                                <span className="work-hours-note">сб-вс: выходной</span>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </Container>
    );
};

export default Contacts;